// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

// HOOKS
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";

// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";
import WidgetContacts from "../Widgets/WidgetContacts/WidgetContacts";
import WidgetPartners from "../Widgets/WidgetPartners/WidgetPartners";
import LoadingIndicator from "../Loaders/LoadingIndicator";
import ServerError from "../Error/ServerError";

// CONFIGURAZIONI
import { appConfig, AGENCY_ID } from "../../config/appConfig";


const Services: React.FC = () => {
    const { t, ready } = useTranslation();
    const { agency, loading: agencyLoading, error: agencyError } = useGetAgencyDetails(AGENCY_ID);

    const imgSrc = '/assets/images/c24.png';
    const imgAlt = t('widgets.partners.c24LogoAlt', 'Logo Casain24ore');
    const url = agency ? `http://www.casain24ore.it/fromsito.php?agReg=${AGENCY_ID}` : '#';

    const services = [
        t('servicesPage.service1'),
        t('servicesPage.service2'),
        t('servicesPage.service3'),
        t('servicesPage.service4'),
        t('servicesPage.service5'),
        t('servicesPage.service6'),
    ];

    if (agencyLoading) return <LoadingIndicator />;
    if (agencyError) return <ServerError />;

    if (!ready) return null;

    return (
        <>

            <Helmet>
                <title>{t('navigation.servicesLinkTitle')} | {agency?.agencyName ?? t('common.defaultAgencyName')}</title>
            </Helmet>

            <SubHeaderDefault title={t('navigation.servicesLinkTitle')} isSeo={false}/>

            <section className="space-ptb services">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-lg-8">
                            <p
                                className="mb-4"
                                dangerouslySetInnerHTML={{ __html: t('servicesPage.parag1') as string }}
                            />
                            <img src={'../assets/images/squadra.jpg'} alt={`${t('servicesPage.imageAlt')}`} className="img-fluid mb-4"/>
                            <ul className="row justify-content-center mb-4 services-list">
                                {services.map((service, index) =>(
                                    <li key={index} className="col-12 col-lg-6 mb-3">
                                        {service}
                                    </li>
                                ))}
                            </ul>
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <img src={'../assets/images/squadra2.jpg'} alt={`${t('servicesPage.imageAlt')}`} className="img-fluid mb-4"/>
                                </div>
                                <div className="col-12 col-md-6">
                                    <img src={'../assets/images/squadra3.jpg'} alt={`${t('servicesPage.imageAlt')}`} className="img-fluid mb-4"/>
                                </div>
                                <div className="col-12 col-md-6">
                                    <img src={'../assets/images/squadra4.jpg'} alt={`${t('servicesPage.imageAlt')}`} className="img-fluid mb-4"/>
                                </div>
                                <div className="col-12 col-md-6">
                                    <img src={'../assets/images/vetrina.jpg'} alt={`${t('servicesPage.imageAlt2')}`} className="img-fluid mb-4"/>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="sidebar">
                                <WidgetContacts
                                    agencyDataAddress={agency?.address_details?.address ?? ''}
                                    agencyDataCity={agency?.address_details?.city_name ?? ''}
                                    agencyDataComuneCapoluogo={false}
                                    agencyDataProvinciaSigla={agency?.address_details?.sigla ?? ''}
                                    agencyDataEmail={appConfig.agency.agencyEmail}
                                    agencyDataEmailShow={appConfig.ui.agencyWidget.showEmail}
                                    agencyDataPhone1={agency?.phone1 ?? ''}
                                    agencyDataPhone2={agency?.phone2 ?? ''}
                                    agencyDataInternationalPrefix={appConfig.agency.intlPrefix ?? '+39'}
                                    agencyDataMobile={agency?.mobile ?? ''}
                                    agencyDataMobile2={agency?.mobile2 ?? ''}
                                    agencyDataFax={agency?.fax ?? ''}
                                    agencySocialShow={appConfig.ui.agencyWidget.showSocialLinks}
                                    agencyDataWhatsapp={appConfig.socialLinks.whatsapp}
                                    agencyDataFacebook={appConfig.socialLinks.facebook}
                                    agencyDataInstagram={appConfig.socialLinks.instagram}
                                    agencyDataTwitter={appConfig.socialLinks.twitter}
                                    agencyDataLinkedin={appConfig.socialLinks.linkedin}
                                    agencyDataPinterest={appConfig.socialLinks.pinterest}
                                    agencyDataYoutube={appConfig.socialLinks.youtube}
                                />
                                <WidgetPartners
                                    partners={[
                                        {
                                            url: url,
                                            data: {
                                                imgSrc: imgSrc,
                                                imgAlt: imgAlt,
                                            },
                                        },
                                    ]}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
};

export default Services;